    // MyForm.js
    import React, { Component } from 'react';
    
    import "./CreaEvento.css";
    class CreaPacchetto extends Component {
        constructor(props) {
            super(props);
            this.state = {
            formData: {
                titolo: '',
                descrizione: '',
                dataInizio: '',
                dataFine: '',
                prezzo: 0,  // Aggiunto campo prezzo con valore di default 0
                immagineCopertina: null,  // Aggiunto campo per l'immagine di copertina
                fileName: null,
                idAzienda: props.azienda
            },
            };
        }
    
        

        handleSubmit = (e) => {
            e.preventDefault();
            this.props.onFormSubmit(this.state.formData);
           
          };
        


        

  
    handleChange = (e) => {
        const { name, value, type, files } = e.target;
    
        if (type === 'file') {
            const reader = new FileReader();
    
            reader.onloadend = () => {
                this.setState((prevState) => ({
                    formData: {
                        ...prevState.formData,
                        immagineCopertina: reader.result,
                        fileName: files[0].name,
                    },
                }));
            };
    
            reader.readAsDataURL(files[0]);
        } else {
            this.setState((prevState) => ({
                formData: {
                    ...prevState.formData,
                    [name]: value,
                },
            }));
        }
    };


    


   
    
    render(){
        const { formData } = this.state;
        return (

    <form onSubmit={this.handleSubmit}>
    <label>
    Titolo:
    <input type="text" name="titolo" value={formData.titolo} onChange={this.handleChange} />
    </label>
    <br />
    <label>
    Descrizione:
    <input type="text" name="descrizione" value={formData.descrizione} onChange={this.handleChange} />
    </label>
    <br />
    <label>
    Data :
    <input
    type="date"
    name="dataInizio"
    value={formData.dataInizio}
    onChange={this.handleChange}
    />
    </label>
    <br />
    <label>
    Data Fine:
    <input
    type="date"
    name="dataFine"
    value={formData.dataFine}
    onChange={this.handleChange}
    />
    </label>
    <br />
    <label>
    Prezzo:
    <input type="number" name="prezzo" value={formData.prezzo} onChange={this.handleChange} />
    </label>

    <br />
    <label>
    Immagine di Copertina:
    <input type="file" name="immagineCopertina" onChange={this.handleChange} />
    </label>
  
    <button type="submit">Invia</button>
      </form>
    
        )};
    }

    export default CreaPacchetto;
